import { Store } from "redux";
import SiteBanner from "storefront/components/SiteBanner";
import createApp from "../../containers/home";

const render = (store: Store) => {
  const target = window.document.getElementById("siteBanner");
  if (target) {
    createApp(target, SiteBanner, store);
  }
};

export default render;
